/* ============================================================
   SOPHIOR — Artikel pagina (progressieve verrijking)
   Gebruikt door sections/sophior-article.liquid (defer geladen).
   1. Link kopiëren-knop bij de deelknoppen
   2. Tabellen in een scroll-wrapper (volle breedte + mobiel scrollbaar;
      zonder JS valt de CSS terug op display:block + overflow-x)
   3. Productmodule: doorklik van artikel naar product meten
   4. Scroll-spy: actieve sectie markeren in de sticky inhoudsopgave
   ============================================================ */
(function () {
  'use strict';

  function init() {
    /* ---- 1. Link kopiëren ---- */
    var copyBtn = document.querySelector('.sophior-article__share-btn--copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var btn = this;
        navigator.clipboard.writeText(btn.dataset.url).then(function () {
          var orig = btn.textContent;
          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = orig; }, 1500);
        });
      });
    }

    /* ---- 2. Tabellen wrappen voor nette kaart-styling + scroll ---- */
    document.querySelectorAll('.sophior-article__content table').forEach(function (table) {
      if (table.closest('.sophior-article__table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'sophior-article__table-scroll';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    /* ---- 3. Productmodule: doorklik meten (P-47) ----
       Publiceert sophior_article_product_click naar Shopify Customer Events.
       Zonder een pixel die erop luistert gebeurt er niets zichtbaars; de
       publish is de themakant van de meting. */
    var bridge = document.querySelector('.sophior-article__products');
    if (bridge) {
      bridge.addEventListener('click', function (e) {
        var item = e.target.closest('.sophior-article__products-item');
        if (!item) return;
        var trigger = e.target.closest('a, button');
        if (!trigger) return;
        if (!window.Shopify || !window.Shopify.analytics ||
            typeof window.Shopify.analytics.publish !== 'function') return;

        window.Shopify.analytics.publish('sophior_article_product_click', {
          article: {
            id: bridge.dataset.articleId || '',
            handle: bridge.dataset.articleHandle || '',
            title: bridge.dataset.articleTitle || '',
            blog: bridge.dataset.articleBlog || ''
          },
          product: {
            id: item.dataset.productId || '',
            handle: item.dataset.productHandle || '',
            title: item.dataset.productTitle || '',
            position: Number(item.dataset.position || 0)
          },
          /* quick_add = knop in de kaart, pdp = doorklik naar de productpagina */
          action: trigger.tagName === 'BUTTON' ? 'quick_add' : 'pdp'
        });
      });
    }

    /* ---- 4. Scroll-spy voor de desktop-inhoudsopgave ---- */
    var tocLinks = Array.prototype.slice.call(
      document.querySelectorAll('.sophior-article__toc .sophior-article__toc-link')
    );
    if (!tocLinks.length) return;

    var headings = [];
    tocLinks.forEach(function (link) {
      var id = decodeURIComponent((link.getAttribute('href') || '').slice(1));
      var heading = document.getElementById(id);
      if (heading) headings.push({ el: heading, link: link });
    });
    if (!headings.length) return;

    /* Zelfde offset als de scroll-margin-top op de koppen (announce + header) */
    var offset = 140;
    var ticking = false;

    function update() {
      ticking = false;
      var current = null;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].el.getBoundingClientRect().top <= offset) {
          current = headings[i].link;
        } else {
          break;
        }
      }
      tocLinks.forEach(function (link) {
        link.classList.toggle('is-active', link === current);
      });
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
